import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useQuery } from 'data-fetching-client';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import { GET_CRM_SEARCH_OBJECT } from 'flow-doctor-lib/queries/CrmObjectQueries';
import { getIdentifierPropertyForObject } from 'flow-doctor-lib/utils/objectUtils';

// Allows the internal FlowDoctor object select to interface with the app-facing ObjectFilterSelect component
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const generateOptionsForObject = resultsData => {
  const options = resultsData.map(obj => ({
    value: obj.objectId,
    text: getIdentifierPropertyForObject(obj) || obj.objectId,
    help: `ID: ${obj.objectId}`
  }));
  return {
    options
  };
};
const getSearchQuery = (newInput, initialFetch, selectedObjectId) => {
  if (selectedObjectId == null || !initialFetch) {
    return newInput;
  }
  return newInput || String(selectedObjectId);
};
const StyledSelectContainer = styled.div.withConfig({
  displayName: "CrmObjectSelect__StyledSelectContainer",
  componentId: "iyri2r-0"
})(["max-width:220px;display:flex;flex-direction:column;"]);
const CrmObjectSelect = ({
  objectTypeId,
  selectedObjectId,
  onChange,
  maxWidth,
  clearable = true
}) => {
  const [isInitialOptionsFetch, setIsInitialOptionsFetch] = useState(true);
  const {
    refetch
  } = useQuery(GET_CRM_SEARCH_OBJECT, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    skip: true
  });
  return /*#__PURE__*/_jsxs(StyledSelectContainer, {
    children: [/*#__PURE__*/_jsx(UISelect, {
      value: selectedObjectId,
      menuWidth: "auto",
      style: {
        maxWidth: maxWidth || 'initial'
      },
      placeholder: I18n.text('flow-doctor-ui.flows.objectLifecycle.search.placeholder'),
      loadOptions: (input, callback) => {
        refetch({
          portalId: PortalIdParser.get(),
          objectTypeId,
          query: getSearchQuery(input, isInitialOptionsFetch, selectedObjectId)
        }).then(res => {
          setIsInitialOptionsFetch(false);
          const options = generateOptionsForObject(res.data.crmSearch.results);
          callback(null, options);
        }).catch(err => {
          console.error(err);
          callback(null, {
            options: []
          });
        });
      },
      onChange: ({
        target: {
          value
        }
      }) => onChange(value ? Number(value) : undefined)
    }), clearable && selectedObjectId && /*#__PURE__*/_jsx(UILink, {
      onClick: () => onChange(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-ui.flows.objectLifecycle.search.clear"
      })
    })]
  });
};
export default CrmObjectSelect;